module.exports = __webpack_public_path__ + "img/arrow-left-button.45d43905.svg";